import get from 'lodash.get';
import InventoryClient from '@/api/InventoryClient';
import SavedAuction from '@/models/SavedAuction';

export const mutations = {
  setTermsOfServiceAccepted(state, accepted) {
    state.termsOfServiceAccepted = accepted;
  },
  setSelectedVehicles(state, vehicles) {
    state.selectedVehicles = vehicles;
  },
  setLaunchedVehicles(state, launchedVehicles) {
    state.launchedVehicles = launchedVehicles;
  },
  setSelectedFilters(state, selectedFilters) {
    state.selectedFilters = selectedFilters;
  },
  setSelectedViewType(state, selectedViewType) {
    state.selectedViewType = selectedViewType;
  },
  togglePerformanceWidget(state) {
    state.performanceWidgetExpanded = !state.performanceWidgetExpanded;
  },
};

export const actions = {
  async getMyInventoryTermsOfService({
    rootState,
    commit,
  }, dealershipId) {
    try {
      const inventoryClient = new InventoryClient(
        rootState.authorization.user,
      );
      const response = await inventoryClient.getTermsOfService(dealershipId);
      const termsAccepted = response.data.data.has_accepted;
      commit('setTermsOfServiceAccepted', termsAccepted);
      return termsAccepted;
    } catch (error) {
      const defaultMessage = 'Failed to retrieve terms of service';
      const errorMessage = error.message || defaultMessage;
      throw new Error(errorMessage);
    }
  },
  async acceptTermsOfService({
    rootState,
    commit,
  }) {
    try {
      const inventoryClient = new InventoryClient(
        rootState.authorization.user,
      );
      await inventoryClient.acceptTermsOfService();
      commit('setTermsOfServiceAccepted', true);
    } catch (error) {
      const defaultMessage = 'Failed to save acceptance of terms of service';
      const errorMessage = error.message || defaultMessage;
      throw new Error(errorMessage);
    }
  },
  setSelectedVehiclesData({ commit }, vehicles) {
    commit('setSelectedVehicles', vehicles);
  },
  async getSavedAuction({
    rootState,
  }, {
    savedAuctionId,
  }) {
    try {
      const inventoryClient = new InventoryClient(rootState.authorization.user);
      const response = await inventoryClient.getSavedAuction(savedAuctionId);
      const savedAuction = new SavedAuction(get(response, 'data.data.saved_auctions[0]'), rootState.currentUser);
      return savedAuction;
    } catch (error) {
      const defaultMessage = 'Failed to get the saved auction';
      const errorMessage = error.message || defaultMessage;
      throw new Error(errorMessage);
    }
  },
  setLaunchedVehiclesData({ commit }, launchedVehicles) {
    commit('setLaunchedVehicles', launchedVehicles);
  },
  setSelectedFilters({ commit }, selectedFilters) {
    commit('setSelectedFilters', selectedFilters);
  },
  setSelectedViewType({ commit }, selectedViewType) {
    commit('setSelectedViewType', selectedViewType);
  },
  togglePerformanceWidget({ commit }) {
    commit('togglePerformanceWidget');
  },
};

export const getters = {
  termsOfServiceAccepted: (state) => state.termsOfServiceAccepted === true,
  selectedVehicles: (state) => state.selectedVehicles,
  launchedVehicles: (state) => state.launchedVehicles,
  selectedFilters: (state) => state.selectedFilters,
  selectedViewType: (state) => state.selectedViewType,
  performanceWidgetExpanded: (state) => state.performanceWidgetExpanded,
};

export const state = {
  termsOfServiceAccepted: false,
  selectedVehicles: [],
  launchedVehicles: {},
  selectedFilters: {},
  selectedViewType: {},
  performanceWidgetExpanded: true,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
